import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {AppStateService} from "../providers/app-state.service";
import {VetReservation} from "../models/vet-reservation.model";
import {VetReservationService} from "../providers/vet-reservation.service";

@Injectable()
export class VrdResolve  implements Resolve<VetReservation> {
  constructor(private vetReservationService: VetReservationService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<VetReservation> {
    this.appStateService.updateIsBusySubject(true);
    let paramMap = route.paramMap;
    if(paramMap.has('param')){
      let param = paramMap.get('param');
      console.log(param)
      return this.vetReservationService.getReservation(param).pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    }


  }
}
